(function () {
  'use strict';

  if (window.PGHomeHeaderV64) return;
  window.PGHomeHeaderV64 = true;

  var desktopQuery = window.matchMedia('(min-width: 799px)');
  var activeTrigger = null;
  var openShell = null;
  var countObserver = null;
  var observedCountSource = null;
  var shellObserver = null;
  var observedShell = null;

  function isDesktop() {
    return desktopQuery.matches;
  }

  function realCartLink() {
    return document.querySelector('[data-desktop-header] .top-bar--right-menu .cart-container .mini_cart') ||
      document.querySelector('[data-desktop-header] .cart-container .mini_cart') ||
      document.querySelector('#header .cart-container .mini_cart');
  }

  function realCartCount() {
    return document.querySelector('[data-desktop-header] .top-bar--right-menu .cart_count') ||
      document.querySelector('[data-desktop-header] .cart_count') ||
      document.querySelector('#header .cart_count');
  }

  function syncCartCount() {
    var source = realCartCount();
    var count = source ? (source.textContent || '').trim() : '0';
    if (!count) count = '0';

    document.querySelectorAll('[data-pg-sticky-cart-count-v64]').forEach(function (node) {
      node.textContent = count;
    });

    if (source && source !== observedCountSource && window.MutationObserver) {
      if (countObserver) countObserver.disconnect();
      observedCountSource = source;
      countObserver = new MutationObserver(syncCartCount);
      countObserver.observe(source, { childList: true, subtree: true, characterData: true });
    }
  }

  function ensureStickyCart(shell) {
    if (!shell || shell.querySelector('[data-pg-sticky-cart-v64]')) return;

    var top = shell.querySelector('.pg-home-sticky-shell__top');
    var cta = shell.querySelector('.pg-home-sticky-shell__cta');
    var source = realCartLink();
    if (!top || !cta || !source) return;

    var link = document.createElement('a');
    var iconClass = source.classList.contains('icon-cart') ? 'icon-cart' : 'icon-bag';
    link.className = iconClass + ' pg-home-sticky-shell__cart-v64';
    link.href = source.getAttribute('href') || '/cart';
    link.setAttribute('data-pg-sticky-cart-v64', '');
    link.setAttribute('aria-label', 'Open cart');
    link.setAttribute('data-no-instant', '');

    var count = document.createElement('span');
    count.className = 'pg-home-sticky-shell__cart-count-v64';
    count.setAttribute('data-pg-sticky-cart-count-v64', '');
    count.setAttribute('aria-hidden', 'true');
    link.appendChild(count);

    link.addEventListener('click', function (event) {
      if (!isDesktop()) return;
      var real = realCartLink();
      if (!real) return;
      event.preventDefault();
      real.click();
    });

    top.classList.add('pg-home-sticky-shell__top--cart-v64');
    cta.insertAdjacentElement('afterend', link);
    syncCartCount();
  }

  function stickyNavFor(shell) {
    return shell ? shell.querySelector('[data-pg-sticky-desktop-nav-v64]') : null;
  }

  function clearOpenPanels(nav) {
    if (!nav) return;
    nav.querySelectorAll('.pg-panel-open').forEach(function (item) {
      item.classList.remove('pg-panel-open');
    });
  }

  function fitPanelToViewport(panel) {
    if (!panel || !isDesktop()) return;

    panel.style.setProperty('--pg-panel-shift', '0px');
    window.requestAnimationFrame(function () {
      if (!document.contains(panel)) return;
      var anchor = panel.offsetParent || document.documentElement;
      var anchorRect = anchor.getBoundingClientRect();
      var panelWidth = panel.offsetWidth;
      var edge = 24;
      var baseLeft = anchorRect.left + (anchorRect.width / 2) - (panelWidth / 2);
      var minLeft = edge;
      var maxLeft = Math.max(edge, window.innerWidth - edge - panelWidth);
      var desiredLeft = Math.min(Math.max(baseLeft, minLeft), maxLeft);
      panel.style.setProperty('--pg-panel-shift', (desiredLeft - baseLeft).toFixed(2) + 'px');
    });
  }

  function bindClonePanels(nav) {
    if (!nav || nav.dataset.pgDesktopPanelsBound === 'true') return;
    nav.dataset.pgDesktopPanelsBound = 'true';

    nav.querySelectorAll('.pg-has-panel').forEach(function (item) {
      var panel = item.querySelector(':scope > .pg-premium-panel');
      var closeTimer = null;

      function openPanel() {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        item.classList.add('pg-panel-open');
        if (panel && (panel.classList.contains('pg-premium-panel--wide') || panel.classList.contains('pg-premium-panel--compact'))) {
          fitPanelToViewport(panel);
        }
      }

      function scheduleClose() {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          if (!item.matches(':hover') && !item.contains(document.activeElement)) {
            item.classList.remove('pg-panel-open');
          }
        }, 260);
      }

      item.addEventListener('mouseenter', openPanel);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', openPanel);
      item.addEventListener('focusout', scheduleClose);
    });
  }

  function observeStickyShell(shell) {
    if (!window.MutationObserver || !shell || observedShell === shell) return;
    if (shellObserver) shellObserver.disconnect();

    observedShell = shell;
    shellObserver = new MutationObserver(function () {
      if (shell.getAttribute('data-pg-visible') !== 'true' && openShell === shell) {
        closeDesktopNav(false);
      }
    });
    shellObserver.observe(shell, { attributes: true, attributeFilter: ['data-pg-visible'] });
  }

  function ensureDesktopNav(shell) {
    if (!shell || !isDesktop()) return null;

    var existing = stickyNavFor(shell);
    if (existing) return existing;

    var source = document.querySelector('[data-desktop-header] .pg-premium-nav');
    var top = shell.querySelector('.pg-home-sticky-shell__top');
    var button = shell.querySelector('[data-pg-sticky-menu]');
    if (!source || !top || !button) return null;

    var wrap = document.createElement('div');
    wrap.className = 'pg-home-sticky-nav-v64';
    wrap.id = 'pg-home-sticky-nav-v64';
    wrap.setAttribute('data-pg-sticky-desktop-nav-v64', '');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.hidden = true;

    var clone = source.cloneNode(true);
    clone.classList.add('pg-home-sticky-nav-v64__nav');
    clone.setAttribute('aria-label', 'Primary navigation');
    wrap.appendChild(clone);

    top.insertAdjacentElement('afterend', wrap);
    button.setAttribute('aria-controls', wrap.id);
    button.setAttribute('aria-expanded', 'false');

    bindClonePanels(wrap);
    observeStickyShell(shell);
    return wrap;
  }

  function setDesktopNavState(shell, open, trigger, restoreFocus) {
    if (!shell) return;
    var nav = stickyNavFor(shell);
    if (!nav && open) nav = ensureDesktopNav(shell);
    var button = shell.querySelector('[data-pg-sticky-menu]');
    if (!nav || !button) {
      if (!open && openShell === shell) openShell = null;
      if (!open) activeTrigger = null;
      return;
    }

    nav.hidden = !open;
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      if (openShell && openShell !== shell) setDesktopNavState(openShell, false, null, false);
      openShell = shell;
      activeTrigger = trigger || button;
    } else {
      clearOpenPanels(nav);
      if (openShell === shell) openShell = null;
      if (restoreFocus && activeTrigger && document.contains(activeTrigger)) activeTrigger.focus();
      activeTrigger = null;
    }
  }

  function toggleDesktopNav(button) {
    var shell = button && button.closest ? button.closest('[data-pg-home-sticky-shell]') : null;
    if (!shell) return;
    var nav = ensureDesktopNav(shell);
    if (!nav) return;
    setDesktopNavState(shell, nav.hidden, button, false);
  }

  function closeDesktopNav(restoreFocus) {
    if (!openShell) return;
    setDesktopNavState(openShell, false, null, restoreFocus !== false);
  }

  function apply() {
    document.querySelectorAll('[data-pg-home-sticky-shell]').forEach(function (shell) {
      ensureStickyCart(shell);
      if (isDesktop()) ensureDesktopNav(shell);
    });
    syncCartCount();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-pg-sticky-menu]') : null;
    if (button && isDesktop()) {
      event.preventDefault();
      event.stopPropagation();
      toggleDesktopNav(button);
      return;
    }

    if (!isDesktop() || !openShell) return;
    var nav = stickyNavFor(openShell);
    var trigger = openShell.querySelector('[data-pg-sticky-menu]');
    if (nav && !nav.contains(event.target) && (!trigger || !trigger.contains(event.target))) {
      closeDesktopNav(false);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openShell) {
      event.preventDefault();
      closeDesktopNav(true);
    }
  });

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function () {
      if (!isDesktop()) closeDesktopNav(false);
      apply();
    });
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(function () {
      if (!isDesktop()) closeDesktopNav(false);
      apply();
    });
  }

  window.addEventListener('resize', function () {
    if (!isDesktop() || !openShell) return;
    var nav = stickyNavFor(openShell);
    if (!nav) return;
    nav.querySelectorAll('.pg-panel-open > .pg-premium-panel--wide, .pg-panel-open > .pg-premium-panel--compact').forEach(fitPanelToViewport);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(apply, 0);
  });

  window.addEventListener('pageshow', apply, { passive: true });
})();
